export default {
  EMAIL: 1,
  SMS: 2
};
